<template>
	<div class="color-display-list">
		<color-list-item v-for="(item,index) in list" v-bind:key="index" :color="item"></color-list-item>
	</div>
</template>
<script type="text/javascript">
	import colorListItem from "@/components/colorListItem.vue";
	export default{
		props:['list'],
		data(){
			return {

			};
		},
		mounted(){
		},components:{
			"color-list-item":colorListItem
		},
		computed:{
			
		}
	}
</script>
<style type="text/css">
	.color-display-list{
		width: 100%;
		max-height: 30vh;
		overflow-y: scroll;
	}
</style>